export const sage = {
  sage_configurations: `SageX3 configurations`,
  sagex3_invoicetype_require: "Invoice type is required.",
  sagex3_facility_required: "Facility is required.",
  sagex3_invoicedate_required: "Invoice date is required.",
  sagex3_supplier_required: "Supplier is required.",
  sagex3_totalwithouttax_required: "Total without tax is required.",
  sagex3_totalwithouttax_must_be_greater_than_zero:
    "Total without tax must be greater than zero.",
  sagex3_comment_length_lessthanorequal_30characters:
    "Comment must be 30 characters or less.",
  sagex3_items_required: "At least one item is required.",
  sagex3_items_productcode_required: "Product code is required for each item.",
  sagex3_items_quantity_required: "Quantity is required for each item.",
  sagex3_items_taxcode_required: "Tax code is required for each item.",
  sagex3_items_both_po_dn_not_allwed_same_item:
    "Both Purchase Order and Delivery Note cannot be used for the same item.",
  sagex3_receiptdate_required: "Receipt date is required.",
  sagex3_receiptdate_unvalid: "Receipt date is invalid.",
  sagex3_items_poitem_required: "PO item is required for each item.",
};
